import React, {useEffect, useState} from 'react';
import styles from './Loader.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRunning, faPersonRunning } from "@fortawesome/free-solid-svg-icons";
import TitleMain from "../Title/TitleMain";

const LoaderSkeleton = () => {

    return (
        <div className={`${styles.containerSkeleton} skeleton`}>
            <div className={styles.loaderSkeleton}>
            </div>
        </div>
    );
};

export default LoaderSkeleton;
